import { createAsyncThunk } from "@reduxjs/toolkit";
import { bffApi, type ContractDto } from "../../../../autogen/bff-api";
import { ContractState } from "../../reducers/contractReducer";
import { untilSettled } from "../../untilSettled";

export const fetchSettledContract = createAsyncThunk<ContractDto, { contractId: string }>(
  "contract/fetchSettled",
  async ({ contractId }, { dispatch, getState, rejectWithValue }) => {
    const select = bffApi.endpoints.getContract.select({ contractId });
    const request = dispatch(bffApi.endpoints.getContract.initiate({ contractId }, { forceRefetch: true }));
    try {
      return await untilSettled(await request, () => select(getState() as Parameters<typeof select>[0]));
    } catch (e) {
      return rejectWithValue(e);
    } finally {
      request.unsubscribe();
    }
  },
);

export const loadContractThunk = createAsyncThunk(
  "contract/load",
  async (
    props: {
      contractId: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const contract = await dispatch(fetchSettledContract({ contractId: props.contractId })).unwrap();
      const loaded: ContractState = {
        id: contract.id,
        contract: contract as ContractState["contract"],
        lastChanged: contract.modifiedAt,
        errors: [],
      };
      return loaded;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
